var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "7px",
    viewBox: "0 0 9 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle 34") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-D---Checkout",
    transform: "translate(-123.000000, -1177.000000)",
    fill: "#1D1C1C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(120.000000, 632.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-34",
    points: "6 552 3 549.083333 4.2 547.916667 6 549.666667 10.8 545 12 546.166667"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e65c61425d8f08130400c10dd933a641.svg";
export { ForwardRef as ReactComponent };